export default __webpack_public_path__ + "static/media/Deathforce Staff.b7b8db3b.jpg";